import AuthHelper from "components/auth/helpers";
import { ApiURL } from "utils/Actions";
import { common } from "utils/Wording";
import { createGetRequest } from "./apiActions";

export const checkAppStatus = async (
  setMaintenanceAction: () => void,
  clearMaintenanceAction: () => void
): Promise<void> => {
  const setMaintenance = () => {
    AuthHelper.clearAuth();
    setMaintenanceAction();
  };

  try {
    const returnData = await createGetRequest({ path: ApiURL.appStatus });
    if (returnData.error) {
      throw new Error(common.serverError);
    }
    returnData?.data?.data?.inMaintenance ? setMaintenance() : clearMaintenanceAction();
  } catch (err) {
    console.error(err);
    setMaintenance();
  }
};
